export default [
    { value: 'default', label: '-----', isDisabled: true },
    { value: 'years_employed_rr', label: 'Years Employed RR'},
    { value: 'years_employed_rr_ia', label: 'Years Employed IA' },
]